import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _Symbol$iterator from "@babel/runtime-corejs3/core-js-stable/symbol/iterator";

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function getSymbolIterator() {
  if (typeof _Symbol !== 'function' || !_Symbol$iterator) {
    return '@@iterator';
  }

  return _Symbol$iterator;
}
export var iterator = /*@__PURE__*/getSymbolIterator();
export var $$iterator = iterator;